// axios 配置

const axios = require('axios');

//axios.defaults.baseURL = '/serv';
axios.defaults.baseURL = 'https://api.xhorse.net.cn/release/web/employeapp';
axios.defaults.headers.common['Authorization'] = 'AUTH_TOKEN';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.timeout = 9000;

export default axios;


// WEBPACK FOOTER //
// ./src/axios/common.js